<template>
    <div v-if="isVisible" class="form-item checkbox" :class="[item.data.htmloptions, { 'is-invalid' : isInvalid }]">

        <Label v-if="item.data.question != ''" :item="item" :is-invalid="isInvalid" />

        <div class="checkbox-item" v-for="answer in answeroptions" :key="answer.id">
            <input type="checkbox"
                :id="answer.id"
                :name="singleCheckbox ? item.data.id : `${item.data.id}[]`"
                :value="answer.value"
                :checked="isChecked(answer)"
                @change="updateFormValue($event, item.data.uniqlabel, answer.value)"
            >
            <i class="icon-form-checkmark"></i>
            <label :for="answer.id"> {{ answer.label }}</label>
        </div>

        <error-message v-if="errorMessage">{{ errorMessage }}</error-message>
    </div>
</template>

<script>
import Label from '../components/Label.vue';
import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";
import eventBus from "../../formeditor/util/EventBus";
import shuffle from "../util/shuffle";
import ErrorMessage from "../components/ErrorMessage.vue"

export default {
    name: 'Checkbox',
    components: {
        Label,
        ErrorMessage
    },
    mixins: [ errorMixin, logicMixin ],
    props: {
        value: {
            type: Array,
            default: () => ([])
        },
        item: {
            type: Object
        },
        formValues: {
            type: Object
        }
    },
    data: function() {
        return {
            selected: [],
            answeroptions: []
        };
    },
    computed: {
        internalValue: {
            get () {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        singleCheckbox () {
            return this.answeroptions.length === 1
        }
    },
    mounted() {
        this.item.data.answeroptions.forEach(answer => {
            if(answer.id_default) {
                this.selected.push(answer.id);
            }
        });

        if(this.item.data.randomorder) {
            this.answeroptions = shuffle(answeroptions);
        }
        else {
            this.answeroptions = this.item.data.answeroptions;
        }

        eventBus.$emit('setValue', this.item.data.id, this.selected);
    },
    methods: {
        isChecked (answer) {
            if (Object.keys(this.formValues).length) {
                return this.formValues[this.item.data.uniqlabel].includes(answer.value)
            } else {
                return this.internalValue.includes(answer.value)
            }
        },
        updateFormValue(event, ident, value) {
            if (Object.keys(this.formValues).length) {
                let updated = this.formValues[this.item.data.uniqlabel]
                if (event.target.checked) {
                    if (this.singleCheckbox) {
                        updated = value
                    } else {
                        updated.push(value)
                    }

                } else {
                    if (this.singleCheckbox) {
                        updated = ''
                    } else {
                        updated = updated.filter(val => val !== value)
                    }

                }
                this.$emit('update-form-value', ident, updated)
            } else {
                if(event.target.checked) {
                    this.internalValue.push(value);
                } else {
                    let index = this.internalValue.findIndex(item => item === value);
                    if (index !== -1) {
                        this.internalValue.splice(index, 1);
                    }
                }
            }
        }
    }
};
</script>